import { createSelector } from 'reselect';
import Decimal from 'decimal.js';

export const getPointsConversionTierName = (state) => state.pointsConversion.name;
export const getRawTiers = (state) => state.pointsConversion.tiers || [];
export const getTiers = createSelector(getRawTiers, (tiers) =>
  tiers.map((tier) => ({ min: new Decimal(tier.min), max: new Decimal(tier.max || Infinity), rate: new Decimal(tier.rate) })),
);
